<template>
  <div>
    <div class="title">门店合作金额</div>

    <el-form>
      <el-form-item
        :label="getNameByValue(mechanismUnionType, r.type)"
        v-for="(r, i) in prices"
        :key="i"
      >
        <div class="flex" style="width: 240px">
          <el-input
            v-model="r.amount"
            placeholder="合作金额"
            type="number"
            :max="1"
            :min="0"
          ></el-input>
          <el-button v-if="r.id" type="primary" @click="updateRatioInfo(r)"
            >更新</el-button
          >
          <el-button v-else type="success" @click="addRatioInfo(r)"
            >添加</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mechanismUnionType } from "../dict.js";
export default {
  data() {
    return {
      prices: [],
      mechanismUnionType,
      init: false
    };
  },

  mounted() {
    this.prices = mechanismUnionType.map((item) => {
      return {
        type: item.value,
        amount: 0,
      };
    });
    this.id = this.$route.query.mecID;
  },

  methods: {
    getList(){
        if(!this.init){
            this.init = true
            this.getRatio()
        }
    },

    getRatio() {
      let data = {
        mechanism_id: this.id,
      };
      this.$get("/user/mechanismUnionPrice/queryListPage", data).then((res) => {
        let all = [...this.prices, ...res.data.data];
        let map = {};
        all.forEach((item) => {
          map[item.type] = item;
        });
        this.prices = Object.values(map);
      });
    },
    updateRatioInfo(row) {
      let data = {
        id: row.id,
        amount: row.amount,
      };
      this.$post("/user/mechanismUnionPrice/update", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
    addRatioInfo(row) {
      let data = {
        mechanism_id: this.id,
        amount: row.amount,
        type: row.type,
      };
      this.$post("/user/mechanismUnionPrice/insert", data).then((res) => {
        this.getRatio();
        this.$emit("success");
      });
    },
  },
};
</script>